// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { RuntimeHostSettings } from './environment.types';
import { readRuntimeSettings } from './environment.runtime';

const settings: RuntimeHostSettings = readRuntimeSettings();

export const environment = {
    production: false,
    url: {
        api: settings.url?.api || 'https://api.ashcorp.xyz',
        web: settings.url?.web || 'https://demo.ashcorp.xyz',
        mobile: settings.url?.mobile || 'https://mobile.ashcorp.co'
    },
    app: {
        name: settings.app?.name || 'DEMO',
        code: settings.app?.code || 'DEMO'
    },
    layout: {
        logo: settings.layout?.logo || 'https://cloud.ashcorp.co/index.php/s/fX7kZWEkEysJrqb/download/logo-20260328151452-e9f33243.png',
        theme: settings.layout?.theme || 'default',
        watermark: settings.layout?.watermark || 'https://cloud.ashcorp.co/index.php/s/Btp2mpragCTSniC/download/watermark-20260328151320-0bcf126c.png',
        favicon: settings.layout?.favicon || 'https://cloud.ashcorp.co/index.php/s/MwMofkqidT9pYPZ/download/favicon-20260328151518-4af7f78e.png'
    },
    support: {
        email: settings.support?.email || 'support@ashcorp.co',
        mobile: settings.support?.mobile || '59729663',
        fullname: settings.support?.fullname || 'Addams',
    },
    user: {
        email: settings.user?.email || '',
        fullname: settings.user?.fullname || '',
        lastname: settings.user?.lastname || '',
        othernames: settings.user?.othernames || '',
        roles: settings.user?.roles || [] as string[],
        superadmin: settings.user?.superadmin === true,
        avatar: settings.user?.avatar || 'https://cloud.ashcorp.co/index.php/s/g7ewbkDSAY6eTC3/download/avatar-20260328152021-746da634.jpeg'
    },
    roles: {
        super: settings.roles?.super === true,
        admin: settings.roles?.admin === true,
        manager: settings.roles?.manager === true,
        user: settings.roles?.user === true
    },
    access: settings.access || {} as Record<string, any>,
    selection: {
        organization: Number.isFinite(settings.selection?.organization as number) ? Number(settings.selection?.organization) : -1,
        branch: Number.isFinite(settings.selection?.branch as number) ? Number(settings.selection?.branch) : -1
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
